import { createRoutes, str, int } from '../typesafe-routes';
import { oldJsonParam } from './utils';


export const cmsRoutes = createRoutes({
  tag: {
    path: ['tag'],
    query: [
      str.optional('tab'),
      int.optional('offset'),
      int.optional('limit'),
      oldJsonParam().optional('searchFilter'),
    ],
  },
  'knowledge-tags': {
    path: ['knowledge-tags'],
    query: [
      str.optional('knowledgeTagId'),
      str.optional('subject'),
      int.optional('offset'),
      int.optional('limit'),
      oldJsonParam().optional('searchFilter'),
    ],
  },
  'knowledge-maps': {
    path: ['knowledge-maps'],
    query: [int.optional('offset'), int.optional('limit'), oldJsonParam().optional('searchFilter')],
  },
  'knowledge-maps/create': {
    path: ['knowledge-maps', 'create'],
  },
  'knowledge-maps/[knowledgeMapId]': {
    path: ['knowledge-maps', str('knowledgeMapId')],
  },
  'search-text': {
    path: ['search-text'],
  },
  'search-question': {
    path: ['search-question'],
  },
  'meta-content/create': {
    path: ['meta-content', 'create'],
  },
  'block-content/create': {
    path: ['block-content', 'create'],
  },
  'block-content/[metaContentId]/edit': {
    path: ['block-content', str('metaContentId'), 'edit'],
    query: [str.optional('chapter'), str.optional('module'), str.optional('activity')],
  },
  grammars: {
    path: ['grammars'],
    query: [
      int.optional('offset'),
      int.optional('limit'),
      oldJsonParam().optional('searchFilter'),
      oldJsonParam().optional('orderBy'),
    ],
  },
  'grammars/[grammarId]': {
    path: ['grammars', str('grammarId')],
    query: [
      int.optional('offset'),
      int.optional('limit'),
      oldJsonParam().optional('searchFilter'),
      oldJsonParam().optional('orderBy'),
    ],
  },
  word: {
    path: ['word'],
    query: [
      int.optional('offset'),
      int.optional('limit'),
      oldJsonParam().optional('searchFilter'),
      oldJsonParam().optional('orderBy'),
    ],
  },
  'word/[wordId]': {
    path: ['word', str('wordId')],
    query: [
      str.optional('defaultTabValue'),
      int.optional('offset'),
      int.optional('limit'),
      oldJsonParam().optional('searchFilter'),
      oldJsonParam().optional('orderBy'),
    ],
  },
  curriculum: {
    path: ['curriculum'],
    query: [
      int.optional('limit'),
      int.optional('offset'),
      oldJsonParam().optional('searchFilter'),
      oldJsonParam().optional('orderBy'),
    ],
    children: {
      '[curriculumId]': {
        path: [str('curriculumId')],
        children: {
          preview: {
            path: ['preview'],
            children: {
              '[dailyCurriculumShortId]': {
                path: [str('dailyCurriculumShortId')],
                children: {
                  '[studyModuleShortId]': {
                    path: [str('studyModuleShortId')],
                    children: {
                      '[studyUnitShortId]': {
                        path: [str('studyUnitShortId')],
                        children: {
                          '[studyUnitActivityShortId]': {
                            path: [str('studyUnitActivityShortId')],
                            children: {
                              '[activityShortId]': {
                                path: [str('activityShortId')],
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          settings: {
            path: ['settings'],
            children: {
              'curriculum-info': {
                path: ['curriculum-info'],
              },
              'linked-curriculums': {
                path: ['linked-curriculums'],
                query: [oldJsonParam().optional('query')],
              },
              'dailycurriculum-setting': {
                path: ['dailycurriculum-setting', str('dailyCurriculumId')],
                query: [
                  int.optional('mcmLimit'),
                  int.optional('mcmOffset'),
                  oldJsonParam().optional('mcmOrderBy'),
                ],
              },
            },
          },
        },
      },
      create: {
        path: ['create'],
      },
    },
  },
  'meta-content': {
    path: ['meta-content'],
    query: [
      int.optional('limit'),
      int.optional('offset'),
      oldJsonParam().optional('searchFilter'),
      oldJsonParam().optional('orderBy'),
    ],
    children: {
      '[metaContentId]': {
        path: [str('metaContentId')],
        children: {
          'content-info': {
            path: ['content-info'],
          },
          'analyze-data': {
            path: ['analyze-data'],
            query: [
              int.optional('analyzeLimit'),
              int.optional('analyzeOffset'),
              oldJsonParam().optional('analyzeOrderBy'),
              oldJsonParam().optional('analyzeSearchFilter'),
            ],
          },
          'all-meta-content-module': {
            path: ['all-meta-content-module', str('metaChapterId')],
            children: {
              '[metaContentModuleId]': {
                path: [str('metaContentModuleId')],
                query: [
                  int.optional('saLimit'),
                  int.optional('saOffset'),
                  oldJsonParam().optional('saSearchFilter'),
                ],
                children: {
                  '[tabName]': {
                    path: [str('tabName')],
                  },
                },
              },
            },
          },
          'chapter-setting': {
            path: ['chapter-setting', str('metaChapterId')],
            query: [
              int.optional('mcmLimit'),
              int.optional('mcmOffset'),
              oldJsonParam().optional('mcmOrderBy'),
              int.optional('saLimit'),
              int.optional('saOffset'),
              oldJsonParam().optional('saSearchFilter'),
              oldJsonParam().optional('saOrderBy'),
              str.optional('mcmId'),
            ],
            children: {
              '[metaContentModuleId]': {
                path: [str('metaContentModuleId')],
                children: {
                  '[tabValue]': {
                    path: [str('tabValue')],
                  },
                },
              },
            },
          },
        },
      },
    },
  },
  'meta-content-module': {
    path: ['meta-content-module'],
    children: {
      '[metaContentModuleId]': {
        path: [str('metaContentModuleId')],
        children: {
          lecture: {
            path: ['lecture'],
            query: [str.optional('focusIndex')],
          },
          'study-activity': {
            path: ['study-activity'],
            children: {
              create: {
                path: ['create'],
                query: [str.optional('type')],
              },
              '[studyActivityId]': {
                path: [str('studyActivityId')],
                query: [oldJsonParam().optional('queryStringObject')],
              },
            },
          },
          'block-activity': {
            path: ['block-activity'],
            children: {
              create: {
                path: ['create'],
              },
              '[activityId]': {
                path: [str('activityId')],
                query: [oldJsonParam().optional('queryStringObject')],
                children: {
                  one: {
                    path: ['one'],
                  },
                },
              },
            },
          },
        },
      },
    },
  },
  'block-content': {
    path: ['block-content'],
    query: [
      int.optional('limit'),
      int.optional('offset'),
      oldJsonParam().optional('searchFilter'),
      oldJsonParam().optional('orderBy'),
    ],
  },
});
